// src/lib/fonts-lazy.ts
let done = false;

const HREF =
  'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@500;600&display=swap';

function onIdle(cb: () => void) {
  const w: any = typeof window !== 'undefined' ? window : undefined;
  if (!w) return;
  return w.requestIdleCallback ? w.requestIdleCallback(cb) : setTimeout(cb, 0);
}

export function ensureFonts() {
  if (done || typeof document === 'undefined') return;
  done = true;
  onIdle(() => {
    // Evitar doble inserción si ya hay una hoja de Google Fonts
    if (document.querySelector('link[rel="stylesheet"][href*="fonts.googleapis.com/css2"]')) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = HREF;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
}